import { StyleSheet, View } from "react-native";
import { MenuItem } from "./MenuItem";
export const MenuList = ({ menus, onMenuToggle }) => {
    return (<View style={styles.container}>
      {menus.map((menu) => (<MenuItem key={menu.id} item={menu} onToggle={onMenuToggle}/>))}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        gap: 8,
    },
});
//# sourceMappingURL=MenuList.js.map